/* STADTHOLZ Uhren-Montage — Ebenen setzen sich per Autoplay oder Klick zusammen.
   Gleiche Mechanik wie sz-fliegen-bau.js: ca. 2,8 s je Ebene, letzte 4,2 s, Klick stoppt,
   läuft nur sichtbar, prefers-reduced-motion zeigt die fertige Uhr. Vanilla JS. */

(function () {
  var STEP_MS = 2800;
  var LAST_MS = 4200;
  var LIFT_BASE = 44; // SVG-Einheiten, erste noch fehlende Ebene
  var LIFT_STEP = 34; // jede weitere Ebene höher

  function setup(root) {
    if (root.__szWatch) return;
    root.__szWatch = true;

    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-layer]'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-watch-step]'));
    var textEl = root.querySelector('[data-watch-text]');
    var toggle = root.querySelector('[data-watch-toggle]');
    if (!layers.length || !buttons.length) return;

    layers.sort(function (a, b) {
      return parseInt(a.getAttribute('data-layer'), 10) - parseInt(b.getAttribute('data-layer'), 10);
    });

    var count = buttons.length;
    var total = layers.length;
    var step = count - 1;
    var timer = null;
    var playing = false;
    var visible = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') !== 'false';

    function show(index) {
      step = index;
      // Letzter Schritt zeigt immer alle Ebenen, auch wenn weniger Schritte als Ebenen gepflegt sind.
      var upto = index === count - 1 ? total - 1 : Math.min(index, total - 1);
      layers.forEach(function (el, i) {
        if (i <= upto) {
          el.style.transform = '';
          el.style.opacity = '';
        } else {
          var lift = LIFT_BASE + (i - upto - 1) * LIFT_STEP;
          el.style.transform = 'translate(0px, ' + -lift + 'px) scale(0.92)';
          el.style.opacity = '0.25';
        }
      });
      buttons.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (textEl) textEl.textContent = buttons[index].getAttribute('data-text') || '';
    }

    function updateToggle() {
      if (!toggle) return;
      toggle.textContent = playing ? 'Animation anhalten' : 'Animation abspielen';
    }

    function schedule() {
      clearTimeout(timer);
      if (!playing || !visible) return;
      timer = setTimeout(function () {
        show((step + 1) % count);
        schedule();
      }, step === count - 1 ? LAST_MS : STEP_MS);
    }

    function stop() {
      playing = false;
      clearTimeout(timer);
      if (textEl) textEl.setAttribute('aria-live', 'polite');
      updateToggle();
    }

    function play() {
      if (reduce) return;
      playing = true;
      if (textEl) textEl.setAttribute('aria-live', 'off');
      if (step === count - 1) show(0);
      updateToggle();
      schedule();
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        stop();
        show(i);
      });
    });

    if (toggle && !reduce && count > 1) {
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        if (playing) {
          stop();
        } else {
          play();
        }
      });
    }

    if (reduce || !autoplay || count < 2) {
      show(count - 1);
      updateToggle();
      return;
    }

    show(0);
    playing = true;
    if (textEl) textEl.setAttribute('aria-live', 'off');
    updateToggle();

    var stage = root.querySelector('.sz-watch__stage') || root;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting;
            if (visible) {
              schedule();
            } else {
              clearTimeout(timer);
            }
          });
        },
        { threshold: 0.35 }
      );
      io.observe(stage);
    } else {
      visible = true;
      schedule();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimeout(timer);
      } else {
        schedule();
      }
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sz-watch]').forEach(setup);
  }

  window.szWatchInit = function () {
    init();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    }, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
